<template>
  <div class="tooltip-container p-relative d-inline-block">
    <span :class="show === 'click' ? 'element-click' : 'element'" @click="handleClick"> <slot /> </span>
    <div
      v-if="show === 'hover' || (show === 'click' && clicked)"
      :style="{ ...position, background: background || '' }"
      class="tooltip p-absolute d-flex bg-system-danger"
      :class="toolTipClassName"
    >
      <span class="text text-b14 text-medium color-cont-white leaning-20">
        <div
          :style="
            background
              ? {
                  borderColor: `${background} transparent transparent transparent`,
                }
              : ''
          "
          class="triangle p-absolute d-flex"
        ></div>
        <p class="text-container d-flex">{{ text }}</p>
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, toRefs } from 'vue';

type TooltipProps = {
  text: string;
  position?: object;
  background?: string;
  show: 'hover' | 'click';
  toolTipClassName?: string;
};

const props = defineProps<TooltipProps>();
const { show } = toRefs(props);
const clicked = ref<boolean>(false);

const handleClick = () => {
  if (show.value === 'click') {
    clicked.value = true;
  }
};
</script>

<style lang="scss" scoped>
@import url('./index.scss');
</style>
